import { Pipe, PipeTransform } from '@angular/core';

/*
 * Format the input to be a JS Date object
 * Takes a string of a date from .NET
 * Usage:
 *   value | dotNetDate
 * Example:
 *   {{ "11/10/2023 12:00:00 AM" |  dotNetDate }}
 *   formats to: Date() object
 */

@Pipe({
    name: 'dotNetDate',
    standalone: true
})
export class DotNetDatePipe implements PipeTransform {
	transform(input: string): Date {
		if (input?.length > 0) {
			const date = new Date(input);
			// strip time zone as it causes issue from .NET
			return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
		}

		return null;
	}
}
